const request = {
    invalid_input: 'Girdi geçersiz. {{details}}',
    general: 'İstek hatası oluştu.',
    range_not_satisfiable: 'Aralık karşılanamıyor.',
};
export default Object.freeze(request);
